<template>
    <v-fab
        class="agent-button"
        icon="icon-stars"
        color="#3FB8D7"
        size="x-small"
        @click="chatOpen = !chatOpen"
    />
    <AgentChat
        v-if="chatOpen"
        v-model="chatOpen"
    />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import AgentChat from '../agentChat/AgentChat.vue';

import { type Languages, useTranslations } from '../../composables';

export interface AgentButtonProps {
    languageCode: Languages;
};

const props = defineProps<AgentButtonProps>();

const { languageCode } = useTranslations();

const chatOpen = ref(false);

watch(() => props.languageCode, (): void => {
    languageCode.value = props.languageCode;
}, { immediate: true });
</script>

<style scoped lang="scss">
@use 'AgentButton.scss';
</style>